import React from 'react';
import { castArray, isNil } from 'lodash';
import { Typography, theme } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import FaIcon, { FaIconProps } from '../FaIcon';
import './styles.scoped.css';

const { Text } = Typography;

type CopyItemObjProps = {
  text: string | number;
  tooltips?: string | string[];
  children?: import('react').ReactElement;
  hoverable?: boolean;
  copyBtnProps?: Omit<FaIconProps, 'icon'>;
} & Omit<TextProps, 'copyable'>;

type CopyItemProps = string | number | CopyItemObjProps;

function CopyItem(props: CopyItemProps) {
  const { token } = theme.useToken();
  let text: number | string;
  let tooltips;
  let children;
  let className;
  let hoverable = true;
  let rest = {};
  let copyBtnProps: CopyItemObjProps['copyBtnProps'] = {};

  if (typeof props === 'string' || typeof props === 'number') text = props;
  else {
    ({ text, tooltips, children, hoverable = true, copyBtnProps, className, ...rest } = props);
  }

  if (isNil(text)) return <>-</>;
  if (!children) children = text;

  tooltips = tooltips ? castArray(tooltips) : ['Click to copy ID'];

  return (
    <Text
      copyable={{
        text: String(text),
        tooltips,
        icon: (
          <FaIcon icon={faCopy} {...copyBtnProps} style={{ color: token.colorTextSecondary }} />
        ),
      }}
      className={classNames(className, { hoverable })}
      {...rest}
    >
      {children}
    </Text>
  );
}

export default CopyItem;
